import React, {useEffect, useMemo} from 'react';
import {RECOMMENDATION_TYPES} from '../../../../constants/SolutionType';
import {useReviewContext} from '../../../../contexts/ReviewContext';
import {recommendFieldsType} from '../recommendFields';
import {useRecommendContext} from '../CreateRecommendHelpers';
import Loading from '../../../../components/Loading/Loading';
import AutoField, {
  ActionType,
  RadioGroupField,
  SelectOption,
} from '../../../../components/AutoForm/AutoFieldNew';
import {useAutoForm} from '../../../../components/AutoForm/useAutoForm';
import {loadRecommendsHowOrFromReview} from '../../hooks/createRecommendHooks';

export {loadRecommendsHowOrFromReview};

// https://teams.microsoft.com/l/message/19:7d7eaee4c35e41e1a4504ae92780f9eb@thread.v2/1760974817021?context=%7B%22contextType%22%3A%22chat%22%7D
// The reason we don't log XO business now is because advisers dont need to do handover notes etc, so when they get an instruction from a client they just ping it to planning support who then process it in Curo, so they dont have to do anything. But adding by Curo is still long, so long term a great solution would be to process XO business in OneView, with planning support doing this. We could do what we do for PAD and disable certain sections like notes, goals etc... and only allow them to add certain recs. But this would mean PS using OneView and some more significant dev. So whilst its something we should do, it will require a shift so something thats on the backlog

export const RecommendHowOptions: React.FC<{
  isSubmitting: boolean;
}> = (props) => {
  const {isSubmitting} = props;
  const {values, setFieldValue} = useAutoForm<recommendFieldsType>();
  const {recommendDetails} = useRecommendContext();
  const {reviewDetails, loadingReview} = useReviewContext();

  useEffect(() => {
    loadRecommendsHowOrFromReview({
      recommendDetails,
      setFieldValue,
      reviewDetails,
    });
  }, [values.how, recommendDetails, reviewDetails]);

  const options = useMemo(() => {
    const tempOptions: SelectOption[] = Object.entries(RECOMMENDATION_TYPES)
      .filter(([k, v]) => {
        if (reviewDetails?.executionOnly) {
          return v === RECOMMENDATION_TYPES.Instruction;
        }
        return true;
      })
      .map(([k, v]) => {
        const disabled = v === 'Instruction' && !reviewDetails?.executionOnly;
        return {
          value: v,
          label: v,
          disabled,
        };
      });
    return tempOptions;
  }, [reviewDetails?.executionOnly]);

  const field: RadioGroupField = useMemo(() => {
    const selectedLabel = values.how
      ? `Providing ${RECOMMENDATION_TYPES[values.how]}`
      : 'Providing...';

    return {
      id: 'how',
      label: selectedLabel,
      boldLabel: true,
      type: ActionType.radioGroup,
      options,
      disabled: true,
    };
  }, [values.how, options]);

  if (loadingReview) {
    return <Loading />;
  }

  return <AutoField field={field} />;
};

export default RecommendHowOptions;
